<template>
  <div class="auth_content opn_content auth_ai">
    <gc-loading :is-show="loadingShow" />

    <div class="ai_top">
      <div v-wechat-title="$t('auth.opnAuth.title')" />
      <authStatus
        :readonly="isStatusShow"
        :auth-status="formData.isauth +''"
        text-type="3"
      />
      <div class="form_bg">
        <van-form :readonly="isReadonly">
          <!-- <div class="form_label">
            <van-field
              v-model="formData.real_name"
              :border="false"
              :name="$t('auth.aiAuth.formText1')"
              :label="$t('auth.aiAuth.formText1')"
              :placeholder="$t('auth.aiAuth.placeholder1')"
              :rules="[{ required: true }]"
              @input="checkErr('real_name_err')"
            />
            <errorText :text="formData.err_auth_info.real_name_err" />
          </div> -->
          <div class="form_label">
            <van-field
              v-model="formData.unit"
              :border="false"
              :name="$t('auth.opnAuth.formText1')"
              :label="$t('auth.opnAuth.formText1')"
              :placeholder="$t('auth.opnAuth.formText1')"
              :rules="[{ required: true }]"
              @input="checkErr('unit_err')"
            />
            <errorText :text="err_auth_info.unit_err" />
          </div>

          <div class="form_label">
            <van-field
              v-model="formData.dutyname"
              :is-link="!isReadonly"
              readonly
              :border="false"
              :name="$t('auth.opnAuth.formText2')"
              :label="$t('auth.opnAuth.formText2')"
              :placeholder="$t('auth.opnAuth.formText2')"
              @click="goPath('/auth/position',{job_type:formData.job_type, job_name:formData.dutyname, unit:formData.unit, type:formData.isauth})"
              @input="checkErr('dutyname_err')"
            />
            <errorText :text="err_auth_info.dutyname_err" />
          </div>
          <div class="form_label no_line">
            <van-field
              v-model="cardtypeText"
              :is-link="!isReadonly"
              readonly
              :border="false"
              :name="$t('auth.nameAuth.formText4')"
              :label="$t('auth.nameAuth.formText4')"
              :placeholder="$t('auth.nameAuth.formText4')"
              @click="cardtypeShowFn()"
            />
          </div>
        </van-form>

        <ImgTitle
          alt="上传图片比标题"
          data-type="4"
          :readonly="!isReadonly"
          :card-type="formData.on_job_type"
        >
          <errorText :text="err_auth_info.on_job_pic_err" />
        </ImgTitle>
        <div class="auth_upload">
          <ossUpload
            v-if="formData.on_job_type != 1"
            :readonly="isReadonly"
            :upload-des="cardtypeText"
            :upload-showback="formData.on_job_pic"
            @getUploadData="getPiccard"
          />
          <template v-else>
            <div v-if="!formData.on_job_pic" class="upload_btn" @click="popupShowFn">
              <span class="upload_tip">{{ $t('auth.opnAuth.formTip2') }}</span>
              <van-icon name="plus" color="#fff" />
            </div>
            <div v-else class="upload_btn">
              <span class="upload_tip">{{ $t('auth.opnAuth.formTip2') }}</span>
              <van-image class="user_img" fit="cover" :src="formData.on_job_pic" @click="previewShowFn" />
              <div v-if="!isReadonly" class="upload_del" @click="delImg()">
                <van-icon name="cross" />
              </div>
            </div>
          </template>
        </div>

      </div>
    </div>

    <!-- 底部按钮展示 认证失败才会展示，然后重新去认证 -->
    <div class="pd_16 auth_bottom">
      <template v-if="isReadonly">
        <div v-if="formData.isauth == 1 || formData.isauth == 2" class="bottom_status">
          <p class="round_safe">
            <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3882 5.76471C16.6588 5.76471 14.1647 4.82353 12.4235 3.17647C12.1882 2.94118 11.8118 2.94118 11.5765 3.17647C9.88235 4.82353 7.34118 5.76471 4.61176 5.76471C4.28235 5.76471 4 6.04706 4 6.37647V13.8588C4 16.2588 5.27059 18.4706 7.34118 19.8353L11.6706 22.6588C11.7647 22.7059 11.9059 22.7529 12 22.7529C12.0941 22.7529 12.2353 22.7059 12.3294 22.6588L16.6588 19.8353C18.7765 18.4706 20 16.2118 20 13.8588V6.37647C20 6.04706 19.7176 5.76471 19.3882 5.76471ZM13.1294 15.9294C13.1294 16.3529 12.6588 16.8235 12 16.8235C11.2941 16.8235 10.8706 16.3529 10.8706 15.9294C10.8706 15.3176 11.5765 14.8941 11.5765 14C11.5765 12.8706 10.5882 11.3176 10.5882 10.3294C10.5882 9.57647 11.1529 9.05882 12 9.05882C12.8471 9.05882 13.4118 9.57647 13.4118 10.3294C13.4118 11.2706 12.4235 12.8706 12.4235 14C12.4706 14.9882 13.1294 15.2706 13.1294 15.9294Z" fill="#666666" />
            </svg>
          </p>
          {{ $t(`auth.aiAuth.statusTip6`) }}
        </div>
        <van-button v-else block type="info" class="mb_50" @click="goAgain('/auth/opnAuth/form')">{{ $t('auth.nameAuth.btnText1') }}</van-button>
      </template>
      <van-button v-else block type="info" class="mb_50" @click="onSubmit()">{{ $t('auth.nameAuth.btnText1') }}</van-button>
    </div>

    <van-action-sheet
      :show="cardtypeShow"
      :round="false"
      :actions="cardtypeInfo"
      :cancel-text="$t('auth.aiAuth.cancel')"
      close-on-click-action
      @select="onSelectType"
      @cancel="onCancel"
    />
    <eDialog
      v-if="popupShow"
      class-name="dialogTip"
      :show-cancel-button="false"
      :confirm-button-text="$t('auth.aiAuth.cancel')"
      @getConfirmEvent="getConfirmEvent"
    >
      <div class="dialog_content">
        <h3 class="mt_30">{{ $t('auth.opnAuth.formTip2') }}</h3>
        <van-image :src="downLoadImg" fit="contain" class="down_img" />
        <div class="tip_btn" @click="downLoad">{{ $t('auth.opnAuth.formTip5') }} <p>{{ $t('auth.opnAuth.formTip55') }}</p></div>
        <van-uploader :after-read="imgUpload">
          <div class="tip_btn">{{ $t('auth.opnAuth.formText3') }}</div>
        </van-uploader>
      </div>
    </eDialog>
  </div>
</template>
<script>
import { ajaxHttp } from '@/api/api'
import { getOssToken, aliyunOss } from '@/utils/aliyunOss'
import utils from '@/utils/utils'
import ImgTitle from '../components/imgTitle/index'
import ossUpload from '@/components/ossUpload'
import eDialog from '@/components/eDialog'
import authStatus from '../components/authStatus/index'
import errorText from '../components/errorText/index'
import { Toast, Form, Field, Icon, Uploader, Button, Image as VanImage, ImagePreview, ActionSheet } from 'vant'

export default {
  name: 'OccupationForm',
  components: {
    ossUpload,
    ImgTitle,
    authStatus,
    errorText,
    vanForm: Form,
    vanField: Field,
    vanIcon: Icon,
    eDialog: eDialog,
    vanUploader: Uploader,
    vanImage: VanImage,
    vanActionSheet: ActionSheet,
    vanButton: Button
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    statusShow: {
      type: Boolean,
      default: false
    },
    authInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      previewShows: false,
      loadingShow: false,
      isGteatChefbrowser: false,
      popupShow: false,
      uploadConf: {},
      pathInfo: {},
      // authStatus: { isauth: '' }, // 认证状态
      formData: {
        isauth: 1, // 认证状态
        dutyname: '',
        unit: '',
        on_job_type: '1',
        on_job_pic: '',
        job_type: ''
      },
      err_auth_info: {
        dutyname_err: '',
        on_job_pic_err: '',
        unit_err: ''
      },
      showBackUrl: '',
      cardtypeShow: false,
      cardtypeInfo: [
        { name: this.$t('auth.opnAuth.formTip2'), val: '1' },
        { name: this.$t('auth.opnAuth.formTip3'), val: '3' },
        { name: this.$t('auth.opnAuth.formTip4'), val: '2' }
      ],
      uploadSite: 'Nuploads/workpic/',
      userInfo: {},
      downLoadImg: ''
    }
  },
  computed: {
    cardtypeText() {
      switch (this.formData.on_job_type) {
        case '3':
          return this.$t('auth.opnAuth.formTip3')
        case '2':
          return this.$t('auth.opnAuth.formTip4')
        default:
          return this.$t('auth.opnAuth.formTip2')
      }
    },
    isReadonly() {
      return this.readonly
    },
    isStatusShow() {
      return this.statusShow
    }
  },
  // watch: {
  //   authInfo: {
  //     handler(newVal, oldVal) {
  //       this.authStatus = newVal
  //     },
  //     immediate: true
  //   }
  // },
  created() {
    const self = this
    // eslint-disable-next-line no-undef
    const dsType = dsBridge.call('openBackButton', 'test')
    /*eslint-disable*/
    if (dsType == 1) { // app内
      self.isGteatChefbrowser = true
    }
    this.$nextTick(() => {
      const { query } = self.$route
      self.pathInfo = query
      self.init()
      // self.getAuthStatus() // 获取认证状态
      // self.getUserData() // 获取用户信息
      // self.isStatusShow && self.getAuthData() // 获取认证信息
      self.getAuthData()
      if (this.pathInfo.job_type && this.pathInfo.job_name) {
        this.formData.job_type = this.pathInfo.job_type
        this.formData.dutyname = this.pathInfo.job_name
        this.formData.unit = this.pathInfo.unit
        this.checkErr('dutyname_err')
        this.checkErr('unit_err')
      }
    })
  },
  methods: {
    previewShowFn(){
      ImagePreview({
        images: [ this.formData.on_job_pic ]
      });
    },
    checkErr($type) {
      this.err_auth_info[$type] = ''
    },
    // getUserData() {
    //   ajaxHttp.$get('/h5/real_auth_info').then(res => {
    //     if (res.code === 1) {
    //       this.userInfo = res.data
    //     } else { Toast(res.message) }
    //   })
    // },
    // getAuthStatus() {
    //   ajaxHttp.$get('/h5/auth_status').then(res => {
    //     if (res.code === 1) {
    //       this.authStatus = res.data.isauth
    //     } else { Toast(res.message) }
    //   })
    // },
    getAuthData() {
      const self = this
      this.loadingShow = true
      ajaxHttp.$get('/h5/get_vocation_info').then(res => {
        if (res.code === 1) {
          this.formData = res.data
          this.err_auth_info = res.data.err_auth_info

          if (this.pathInfo.job_type && this.pathInfo.job_name) {
            this.formData.job_type = this.pathInfo.job_type
            this.formData.dutyname = this.pathInfo.job_name
            this.formData.unit = this.pathInfo.unit
            this.checkErr('dutyname_err')
            this.checkErr('unit_err')
          }
        } else { Toast(res.message) }
        this.$nextTick(() => {
          self.loadingShow = false
        })
      })
    },
    goAgain($url) {
      this.$router.push({ path: $url, query: { lang_id: this.pathInfo.lang_id }})
    },
    onSubmit() {
      const data = { ... this.formData }
      if (!data.unit) {
        return Toast(this.$t('auth.opnAuth.formText1'))
      }
      if (!data.dutyname) {
        return Toast(this.$t('auth.opnAuth.formText2'))
      }
      if (!data.on_job_pic) {
        return Toast(this.$t('auth.opnAuth.formTip') + this.cardtypeText)
      }

      ajaxHttp.$post('/h5/submit_vocation_info', data).then(res => {
        if (res.code === 1) {
          if (this.isStatusShow) {
            location.reload()
          } else {
            this.$router.replace({ path: '/auth/status', query: { type: '3', lang_id: this.pathInfo.lang_id }})
          }
        } else { Toast(res.message) }
      })
    },
    async init() {
      const $ossData = await getOssToken()
      const $ossConfig = $ossData
      this.uploadConf.stsToken = $ossConfig.Credentials.SecurityToken
      this.uploadConf.accessKeyId = $ossConfig.Credentials.AccessKeyId
      this.uploadConf.accessKeySecret = $ossConfig.Credentials.AccessKeySecret
      this.uploadConf.bucket = $ossConfig.Bucket.BucketName
      this.uploadConf.endPoint = $ossConfig.Bucket.EndPoint
    },
    imgUpload({ file }, info) {
      const self = this
      const aliyun = { // oss 密钥配置
        region: '/front',
        stsToken: this.uploadConf.stsToken,
        accessKeyId: this.uploadConf.accessKeyId,
        accessKeySecret: this.uploadConf.accessKeySecret,
        bucket: 'greatchefupload',
        endpoint: 'https://oss-accelerate.aliyuncs.com'
      }
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        overlay: true,
        duration: 99999
      })
      const filePath = self.uploadSite // 上传的目录，这个根据上面接口返回的参数的value来确定目录位置
      const arr = file.name.split('.')
      const suffix = arr[arr.length - 1]
      const fileName = `${Date.parse(new Date())}${parseInt(1000000 * Math.random())}.${suffix}` // 生成的文件名，上传成功要传给后端哦
      const allPath = `${filePath}${fileName}` // 拼接好上传的目录和文件名
      aliyunOss(aliyun).put(allPath, file, {
        timeout: 30 * 1000
      }).then(({ res, url, name }) => {
        if (res && res.status === 200) {
          this.formData.on_job_pic = res.requestUrls[res.requestUrls.length - 1]
          this.formData.on_job_pic_name = fileName
          this.popupShow = false
          Toast.clear()
        }
      }).catch((err) => {
        console.log(`阿里云OSS上传图片失败回调`, err)
      })
    },
    delImg() { // 删除图片
      this.formData.on_job_pic = ''
      this.checkErr('on_job_pic_err')
    },
    getPiccard($info) {
      console.log('图片上传')
      this.formData.on_job_pic = $info.path
      this.formData.on_job_pic_name = $info.name
    },
    onSelectType(action, index) {
      this.formData.on_job_type = action.val
      this.cardtypeShow = false
      this.$forceUpdate()
    },
    getConfirmEvent() {
      this.popupShow = false
    },
    async popupShowFn() { // 弹出 职业认证模版dialog
      console.log(1234);
      if (this.isReadonly) { return false }
      if (!this.formData.dutyname || !this.formData.unit) {
        return Toast('请完善认证信息')
      }

      // 获取用户信息 创建职业模版需要用户数据
      let userInfo = await ajaxHttp.$get('/h5/real_auth_info')
      const data = {
        auth_real_name: userInfo.data.real_name,
        id_number: userInfo.data.id_number,
        dutyname: this.formData.dutyname,
        unit: this.formData.unit
      }
      const imgUrl = await ajaxHttp.$get('/h5/on_job_img', data)
      this.downLoadImg = imgUrl.data.url
      this.popupShow = true
      this.$forceUpdate()
    },
    cardtypeShowFn() {
      if (this.isReadonly) { return false }
      this.cardtypeShow = true
    },
    onCancel() {this.cardtypeShow=false},
    goPath($url, $parame = {}) {
      if (this.isReadonly) { return false }
      this.$router.push({ path: $url, query: $parame })
    },
    async downLoad() {
      if (this.isGteatChefbrowser) {
        utils.downloadImg(this.downLoadImg).then((res) => {
          // Toast('下载成功')
        })
      } else {
        utils.downloadIamge(this.downLoadImg)
      }
    },
    onChange() { console.log(1111); this.previewShows = false }
  }
}
</script>
<style lang="scss">
  .van-uploader,.van-uploader__input-wrapper {
    width: 100%;
}
</style>

<style lang="scss" scoped>
.van-uploader__input-wrapper {
  width: 100%;
  position: relative;
}
.dialog_content{
  padding: 0;
  text-align: center;
  overflow: hidden;
}
.down_img{
  width: 100%;
  height: 45vh;
}
</style>
